module.exports = __webpack_public_path__ + "static/media/tabHtml.5bc11029.png";